import { Component } from '@angular/core';

@Component({
    selector: 'cmps-event-centre-card-name',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-event-centre-card-name',
    },
})
export class CardNameComponent {}
